import React from 'react';
import { Box } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

const SocialAccountDivider = () => {
  const { t } = useTranslation();

  return (
    <Box
      display="flex"
      flexDirection="row"
      alignItems="center"
      gap="4px"
      my="24px"
    >
      <Box flex={1} borderBottom="1px solid #888888" />
      <Box
        fontSize="12px"
        fontWeight={500}
        color="#888888"
        textAlign="center"
        whiteSpace="nowrap"
      >
        {t('login in with social account')}
      </Box>
      <Box flex={1} borderBottom="1px solid #888888" />
    </Box>
  );
};

export default SocialAccountDivider;
